export default "__VITE_ASSET__CZGRIx6T__"